import React from 'react';
import PropTypes from 'prop-types';

const ContactCard = ({ emailContact, phoneContact, title, schedule, key, theme }) => {
  return (
    <div className={`contact block ${theme}`} key={key}>
      <div className="core">
        <div className="par title">{title}</div>
        <div className="par top">
          <a href="mailto:service.partenaire@nortia-protect.fr" target="_blank" rel="noopener noreferrer">{emailContact}</a>
        </div>
        <div className="par bottom phone">{phoneContact}</div>
        <div className="par top"></div>
      </div>
    </div>
  );
};

ContactCard.propTypes = {
  title: PropTypes.string,
  emailContact: PropTypes.string,
  phoneContact: PropTypes.string,
  scheduleContact: PropTypes.string,
  icon: PropTypes.string,
  fill: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  extras: PropTypes.array,
};

ContactCard.defaultProps = {
  title: "BESOIN D'EN SAVOIR + ?",
  emailContact: 'service.partenaire@nevidis.fr',
  phoneContact: '01 87 66 84 31',
  scheduleContact: '',
  icon: 'contact',
  fill: '#0d1d70',
  extras: [],
};

export { ContactCard };
